import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Services() {
  const services = [
    {
      icon: 'ri-file-text-line',
      title: 'Content Management',
      description: 'End-to-end expertise in content management systems including OpenText, Adobe AEM, Drupal, Sitecore, and WordPress. We provide software development, customization, operations support, content creation, and media processing services.',
      highlights: [
        'CMS Development & Customization',
        'Content Creation & Management',
        'Media Processing & Editing',
        'DAM & CDN Systems',
        'Large-Scale Content Migration'
      ],
      image: 'https://public.readdy.ai/ai/img_res/ebc891b8e4723b94ba0c76a09dc9c7a5.jpg'
    },
    {
      icon: 'ri-search-line',
      title: 'Search and Commerce',
      description: 'Deep experience in enterprise search solutions leveraging Elastic, Solr, Endeca, and Lucidworks Fusion. We architect AI-powered intelligent search and build commerce solutions using Magento, Mirakl, SAP Hybris, and Pimcore.',
      highlights: [
        'Enterprise Search Architecture',
        'AI-Powered Cognitive Search',
        'Commerce Platform Development',
        'UMART44 Commerce Platform',
        'Search Technology Optimization'
      ],
      image: 'https://readdy.ai/api/search-image?query=Ecommerce%20platform%20dashboard%20with%20product%20catalog%20search%20results%20and%20analytics%20charts%20displayed%20on%20a%20sleek%20monitor%20in%20a%20bright%20modern%20office%20with%20white%20background%20showing%20shopping%20cart%20icons%20and%20data%20visualizations%20representing%20an%20advanced%20online%20retail%20technology%20solution&width=800&height=600&seq=service-search-002&orientation=landscape'
    },
    {
      icon: 'ri-cloud-line',
      title: 'DevOps and Cloud',
      description: 'Expert cloud practitioners with experience in AWS, Azure, and GCP. We architect cloud-native solutions and migrate legacy applications using lift-and-shift, technology refresh, or rewrite strategies.',
      highlights: [
        'Cloud Architecture & Migration',
        'AWS, Azure, GCP Expertise',
        'DevOps Culture & Practices',
        'CI/CD Pipeline Automation',
        'Infrastructure as Code'
      ],
      image: 'https://readdy.ai/api/search-image?query=Cloud%20computing%20infrastructure%20diagram%20with%20interconnected%20server%20nodes%20and%20deployment%20pipelines%20visualized%20on%20a%20large%20screen%20in%20a%20modern%20data%20center%20operations%20room%20with%20clean%20white%20walls%20glowing%20server%20racks%20and%20engineers%20monitoring%20systems%20in%20a%20high-tech%20environment&width=800&height=600&seq=service-cloud-003&orientation=landscape'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Application Development & Digital Transformation',
      description: 'Passionate about developing world-class web and mobile applications powered by microservices architecture. Rich experience in UX, UI, and RESTful API development with domain-driven design using hexagonal architecture.',
      highlights: [
        'Web & Mobile Applications',
        'Microservices Architecture',
        'UX/UI Design & Development',
        'RESTful API Development',
        'Legacy Application Modernization'
      ],
      image: 'https://readdy.ai/api/search-image?query=Software%20development%20team%20working%20on%20mobile%20app%20and%20web%20application%20UI%20designs%20with%20wireframes%20and%20code%20editors%20open%20on%20multiple%20screens%20in%20a%20bright%20collaborative%20open-plan%20office%20with%20whiteboards%20showing%20architecture%20diagrams%20and%20a%20clean%20modern%20aesthetic&width=800&height=600&seq=service-appdev-004&orientation=landscape'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Application and Operations Support',
      description: 'Highly cost-effective multi-level application and operations support. Our engineers are analytical experts in APM tools like Dynatrace, AppD, DataDog, CloudWatch, and log aggregators like Splunk, Sumo, and Logstash.',
      highlights: [
        'Multi-Level Support Services',
        'APM Tools Expertise',
        'Log Aggregation & Analysis',
        'Automated Incident Management',
        'Application Availability Optimization'
      ],
      image: 'https://readdy.ai/api/search-image?query=IT%20operations%20monitoring%20center%20with%20multiple%20large%20screens%20displaying%20real-time%20system%20performance%20dashboards%20application%20health%20metrics%20and%20log%20analytics%20in%20a%20professional%20support%20center%20with%20clean%20organized%20workstations%20and%20calm%20ambient%20lighting%20showing%20uptime%20graphs%20and%20alert%20panels&width=800&height=600&seq=service-ops-005&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20technology%20workspace%20with%20multiple%20computer%20screens%20displaying%20code%20and%20data%20analytics%20dashboards%20in%20a%20bright%20professional%20office%20environment%20with%20clean%20minimalist%20design%20and%20soft%20natural%20lighting%20creating%20an%20atmosphere%20of%20innovation%20and%20technical%20excellence&width=1920&height=600&seq=services-hero-bg&orientation=landscape"
            alt="Services Hero Background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-6xl font-bold text-white mb-6">Our Services</h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            Comprehensive IT services and solutions designed to drive your business forward with cutting-edge technology and expert execution
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#1E3A5F] mb-4">What We Offer</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              From content management to cloud solutions, we deliver excellence across the entire technology spectrum
            </p>
          </div>

          <div className="space-y-20">
            {services.map((service, index) => (
              <div
                key={index}
                className={`flex flex-col ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                } gap-12 items-center`}
              >
                <div className="lg:w-1/2">
                  <div className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-xl transition-shadow duration-300">
                    <div className="w-16 h-16 flex items-center justify-center bg-[#14B8A6]/10 rounded-xl mb-6">
                      <i className={`${service.icon} text-3xl text-[#14B8A6]`}></i>
                    </div>
                    <h3 className="text-3xl font-bold text-[#1E3A5F] mb-4">{service.title}</h3>
                    <p className="text-gray-600 leading-relaxed mb-6">{service.description}</p>
                    <ul className="space-y-3">
                      {service.highlights.map((highlight, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <i className="ri-check-line text-[#14B8A6] text-xl mt-0.5"></i>
                          <span className="text-gray-700">{highlight}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="lg:w-1/2">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-[400px] object-cover rounded-2xl shadow-lg"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technology Stack */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#1E3A5F] mb-4">Technologies We Master</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Our expertise spans across industry-leading platforms and cutting-edge technologies
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8">
            {[
              'OpenText', 'Adobe AEM', 'Drupal', 'Sitecore', 'WordPress', 'Elastic',
              'Solr', 'Magento', 'SAP Hybris', 'AWS', 'Azure', 'GCP',
              'Kubernetes', 'Docker', 'Jenkins', 'Dynatrace', 'Splunk', 'DataDog'
            ].map((tech, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-xl p-6 text-center hover:bg-[#14B8A6]/5 hover:shadow-md transition-all duration-300 cursor-pointer"
              >
                <p className="text-[#1E3A5F] font-semibold">{tech}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#1E3A5F] mb-4">Why Choose Uniti Tech</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Our commitment to excellence sets us apart in the industry
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: 'ri-team-line',
                title: 'Expert Team',
                description: 'Highly skilled engineers with deep domain expertise and proven track records'
              },
              {
                icon: 'ri-money-dollar-circle-line',
                title: 'Cost Effective',
                description: 'Competitive pricing with optimal cost models and minimal overheads'
              },
              {
                icon: 'ri-lightbulb-line',
                title: 'Innovation Driven',
                description: 'Staying ahead of emerging trends and technologies to deliver cutting-edge solutions'
              },
              {
                icon: 'ri-shield-check-line',
                title: 'Quality Focused',
                description: 'Detail-oriented approach ensuring high quality, performance, and reliability'
              }
            ].map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 text-center"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-[#14B8A6]/10 rounded-full mx-auto mb-6">
                  <i className={`${item.icon} text-3xl text-[#14B8A6]`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-[#1E3A5F]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Ready to Transform Your Business?</h2>
          <p className="text-xl text-white/90 mb-10 leading-relaxed">
            Let's discuss how our services can help you achieve your business goals and drive digital transformation
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="px-10 py-4 bg-[#14B8A6] text-white rounded-full font-semibold hover:bg-[#0F9B8E] transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Get Started
            </a>
            <a
              href="/engagement"
              className="px-10 py-4 bg-transparent border-2 border-white text-white rounded-full font-semibold hover:bg-white hover:text-[#1E3A5F] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View Engagement Models
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}